import Nav from "./nav"
import Service from "./service"
import Global from "./global"
import ServicesResult from "./services-result"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Global(jQuery)
    Service(jQuery)
    ServicesResult(jQuery)
})
